import { Button, Icon } from "@trimble/modus-cmx";

type ProductPricelistExportButtonProps = {
  label: string;
  onExport: () => void;
  loading?: boolean;
  disabled?: boolean;
  testId?: string;
};

function ProductPricelistExportButton({
  label,
  onExport,
  loading = false,
  disabled = false,
  testId,
}: ProductPricelistExportButtonProps) {
  return (
    <Button
      color="primary"
      size="sm"
      shape="rectangle"
      data-testid={testId}
      loading={loading}
      disabled={disabled}
      onButtonClick={onExport}
    >
      <Icon name="file_type_csv" variant="solid" size="sm" decorative />
      {label}
    </Button>
  );
}

export default ProductPricelistExportButton;
